// D3: scoped query-key factory. A read is workspace-keyed iff its request
// depends on X-Workspace-Id. Org/user/super-admin/public reads use their own
// boundary and are not prefixed with the active workspace id.
export const qk = {
  workspace: (wsId: string, ...parts: readonly unknown[]) =>
    ['workspace', wsId, ...parts] as const,
  org: (orgId: string, ...parts: readonly unknown[]) =>
    ['org', orgId, ...parts] as const,
  user: (...parts: readonly unknown[]) => ['user', ...parts] as const,
  superAdmin: (...parts: readonly unknown[]) => ['superAdmin', ...parts] as const,
  public: (...parts: readonly unknown[]) => ['public', ...parts] as const,
};
